<template>
	<div class="poi" v-if="poi" v-observe-visibility="visibilityChanged">
        <div class="poi-header">
            <div class="poi-floor" v-if="showFloor && poi.getFloor()">
                <icon name="floor"/>
                <label v-html="poi.getFloor().getName(language) || ''"/>. <label v-wf-translate="'floor'">korrus</label>
            </div>
            <div class="poi-close" @click="closeOverlay">
                <label v-wf-translate="'close'">Sulge</label>
                <icon name="close"></icon>
            </div>
        </div>
        <div class="poi-body">
            <div class="poi-properties">
                <div class="poi-logo-opening">
                    <div class="poi-image" v-if="showLogo" :style="{'background-image': getImage()}" :class="[isImage()]"></div>
					<div class="poi-opening" v-if="poi.opening_times && !poi.opening_times['24h']">
						<icon name="clock"/>
						<div class="poi-opening-day" v-for="(d, index) in poi.opening_times.days" :key="index" :class="{'active': index == currentDayIndex}">
							<div class="day">{{days[index]}}</div>
							<div >
								<div class="start">{{d.from}}</div>
								<div class="end">{{d.to}}</div>
							</div>
						</div>
					</div>
					<div class="poi-opening" v-if="poi.opening_times && poi.opening_times['24h']">
						<icon name="clock"/>
						<div v-for="(d, index) in days" :key="index" :class="{'active': index == currentDayIndex}">
							<div class="day">{{days[index]}}</div>
							<div>24h</div>
						</div>
					</div>
				</div>
                <div>
                    <h3 v-html="poi.getGroupNames(language) && poi.getGroupNames(language).join(',') || ''"></h3>
                    <div class="poi-contact">
                        <h2 class="poi-name" v-if="showName" v-html="poi.getName(language) || ''"></h2>
                        <div class="poi-contact-body">
                            <ul class="poi-addresses">
                                <li class="poi-phone">{{poi.phone && poi.phone.join(" ") || ''}}</li>
                                <li class="poi-email">{{poi.email && poi.email.join(" ") || ''}}</li>
                                <li class="poi-url">{{poi.web}}</li>
                            </ul>
                            <button class="button action" v-touch:tap="showPath">
                                <label v-wf-translate="'show_path'">Show path</label> <icon name="arrow"/>
                            </button>
                        </div>
                    </div>
                </div>
				
            </div>
			<div class="poi-description" v-if="showDescription" v-html="poi.getDescription(language) || ''"></div>
        </div>	
	</div>
</template>

<script>
/* global wayfinder: false */
import { mapState } from 'vuex';
import { WFScrollableArea } from '@3dwayfinder/wayfinder-vue-components'


export default {
	name: "POI",
	components: {
		WFScrollableArea,
	},
	computed: {
		...mapState('wf',['language'])
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: true
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: true
		},
		showDescription: {
			type: Boolean,
			default: true
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: true
		}
	},
	mounted () {
		let currentDay = (new Date()).getDay();
		this.currentDayIndex = currentDay == 0 ? 6 : currentDay - 1;
		this.$wayfinder.translator.translate();
		this.show_path = this.$wayfinder.translator.get('show_path');
	},
	watch: {
		language () {
			if (wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
			}
		}
	},
	methods: {
		visibilityChanged (a1) {
			this.$wayfinder.translator.translate();
		},
		update (id) {
			/* global wayfinder window */
			if (wayfinder.pois[id]) {
				this.poi = Object.freeze(wayfinder.pois[id]);
				this.language = wayfinder.getLanguage()
				this.$emit('titleChanged', this.poi.getName(wayfinder.getLanguage()))
				this.description = this.poi.getDescription(wayfinder.getLanguage()) ? this.poi.getDescription(wayfinder.getLanguage()) : '';
				if (this.poi.shop_logo) {
					var scope = this;
					window.requestAnimationFrame(function () {
						scope.$app.getImage(scope.poi.shop_logo).then(function (image) {
							scope.logo = image.url
						})
					});
				}
			}
		},
		showPath () {
			if (this.poi) {
				this.$emit('showPath', this.poi);
			}
		},
		open (type) {
			if (type && this.poi[type]) {
				if (type === 'shop_email') {
					window.open('mailto:' + this.poi[type], '_system')
				}
				else if (type === 'shop_phone') {
					window.open('tel:' + this.poi[type], '_system')
				}
				else {
					window.open(this.poi[type], '_system')
				}
			}
		},
		getImage () {
			if (typeof this.poi.logo == "string") {
				return 'url("' + this.poi.logo  + '")';
			}
			else {
				return "url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIj48dGl0bGU+UGhvdG88L3RpdGxlPjxnIGlkPSJQaG90byIgc3Ryb2tlPSIjNEE0QTRBIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3QgaWQ9IlJlY3RhbmdsZS0xNiIgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIiLz48cGF0aCBpZD0iUGF0aC05IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNC44NjggMTlsMy43NjYtOS4wNDggNC4yMyA3LjQzNiAyLjQwNC00LjAwN0wxOS4wNjIgMTl6Ii8+PGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjE2IiBjeT0iNy4xMzMzMzMzMyIgcj0iMi4xMzMzMzMzMyIvPjwvZz48bWV0YWRhdGE+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpyZGZzPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwLzAxL3JkZi1zY2hlbWEjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iPjxyZGY6RGVzY3JpcHRpb24gYWJvdXQ9Imh0dHBzOi8vaWNvbnNjb3V0LmNvbS9sZWdhbCNsaWNlbnNlcyIgZGM6dGl0bGU9InBob3RvIiBkYzpkZXNjcmlwdGlvbj0icGhvdG8iIGRjOnB1Ymxpc2hlcj0iSWNvbnNjb3V0IiBkYzpkYXRlPSIyMDE4LTA2LTI4IiBkYzpmb3JtYXQ9ImltYWdlL3N2Zyt4bWwiIGRjOmxhbmd1YWdlPSJlbiI+PGRjOmNyZWF0b3I+PHJkZjpCYWc+PHJkZjpsaT5BdmluYXNoIFA8L3JkZjpsaT48L3JkZjpCYWc+PC9kYzpjcmVhdG9yPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L21ldGFkYXRhPjwvc3ZnPg==')";
			}
		},
		isImage () {
			if(this.poi.getBackgroundUrl()) return "image-background";
			else if (this.poi.getIconUrl()) return "image-logo";
			else return "image-none";
		},
		truncate (str, len) {
			if (str && str.length > len) {
				return str.substring(0, len) + '...';
			}
			else {
				return str;
			}
		},
        closeOverlay () {
            this.$emit('close');
        }
	},
	data: function () {
		return {
			show_path: 'Show Path',
			days: ["E", "T", "K", "N", "R", "L", "P"],
			currentDayIndex: 0
		}
	}
};
</script>

<style lang="less" scoped>
    @import '../theme/variables';

    .poi-header {
        height: 5rem;
        display: flex;
        padding: 0.9rem 1.2rem;
        box-shadow: 0px 8px 18px -6px rgba(24, 39, 75, 0.12), 0px 12px 42px -4px rgba(24, 39, 75, 0.12);

        .poi-floor {
            height: 100%;
            display: flex;
            align-items: center;
            font-size: 1.1rem;

            .icon {
                height: 1rem;
                margin-right: 0.5rem;
                margin-bottom: 0.1rem;
                --color1: black;
            }
        }
    }

    .poi-close {
        margin-left: auto;
        height: 100%;
        font-size: 1.1rem;
        display: flex;
        align-items: center;

        .icon {
            background-color: @action-color;
            width: @menus-col-height;
            height: @menus-col-height;
            padding: 0.6rem;
            border-radius: @corner-radius-medium;
            margin-left: 0.6em;
        }
    }

	.layout-view {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}
	
	.poi-info {
		padding: 1rem;
		
	}

	.poi-info h2 {
		text-align: center;
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}

	.poi-body {
		box-shadow: 0px -2px 1px 0 rgba(0, 0, 0, 0.05);
		flex-grow: 1;
	}

	.poi-image {
		height: 10rem;
		width: 80%;
		background-position: 50% 50%;
		background-size: contain;
		background-repeat: no-repeat;
	}

	.poi-image.image-background {
		background-size: cover;
	}
	
	.show-path {
		bottom: 1rem;
		right: 1rem;
		text-transform: uppercase;
		z-index: 10;
		line-height: 2.8rem;
		margin-bottom: 1.5rem;		
	}

	.show-path button {
		height: 3rem;
		font-size: 1.2rem;
		line-height: 2.8rem;
		padding-left: 2.5rem;
		padding-right: 2.5rem;
		margin: auto;
		border: 0;
		display: block;
	}
	
	.poi-description {
		line-height: 1.2;
        font-size: 0.9rem;
        border-top: 1px solid #EBE9E9;
        padding: 1.7rem 3.2rem;
	}

    .poi-contact {
        background-color: @light-background;
        padding: 1rem;

        .poi-contact-body {
            display: flex;
            align-items: flex-end;

            ul {
                margin: 0;
                padding: 0;
                list-style-type: none;
                font-size: 0.8rem;
                width: 50%;
                
                li {
                    margin-top: 1em;
                }

                .poi-url {
                    font-size: 1.1rem;
                    color: @font-color-highlight;
                }
            }

            button.action {
                margin-left: auto;
                width: 50%;
            }
        }

        .poi-name {
            font-size: 2.1rem;
            margin-top: 0;
        }
    }

	.poi-contact .address {
		font-weight: 600;
		margin-bottom: 0.5rem;
	}

	.poi-contact .address span {
		padding-top: 4px;
		vertical-align: top;
		display: inline-block;
	}

	.poi-contact .address a {
		text-decoration: none;
		display: block;
		line-height: 1.5;
	}

	.poi-contact .address .icon:before {
		mix-blend-mode: initial;
		color: white;
	}

    .poi-properties {
        display: flex;
        justify-content: space-around;
        padding: 2rem 3.2rem;
        
        & > * {
            width: 50%;
        }
    }

    .poi-opening {
        display: flex;
        align-items: center;
		margin-top: 1rem;

        .poi-opening-day {
            margin: 0.3rem;
            font-size: 0.8rem;
            text-align: center;
            padding: 0.4rem 0.2rem;

            &.active {
                background-color: @action-color;
                color: @action-font-color;
                border-radius: @corner-radius-small;
            }

            .day {
                font-weight: 500;
            }
        }
    }

</style>
